export default __webpack_public_path__ + "static/media/Moon.12d27a9d.svg";